module.exports = __webpack_public_path__ + "img/empty.3685e111.svg";